import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { WorkspaceData, WorkspaceUserData } from "../../types";
import { useRemoveUserModal } from "./hooks";

type RemoveUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  workspaceData?: WorkspaceData;
  userData: WorkspaceUserData | null;
};

const RemoveUserModal = ({
  workspaceData,
  userData,
  isOpen,
  onClose,
}: RemoveUserModalProps) => {
  const { endArenaAccess, loading } = useRemoveUserModal();

  const handleRemoveUser = async () => {
    await endArenaAccess({
      arenaIds: [workspaceData?.id ?? -1],
      userIds: [userData?.adminArenaUserId ?? "-1"],
    });
    onClose();
  };

  return (
    <ModalV2
      data-testid="remove-user-modal"
      title="Remove user from workspace"
      description={workspaceData?.name}
      show={isOpen}
      onHide={onClose}
      size="small"
    >
      <ModalV2.Body>
        <Text variant="regular-lg" marginBottom="md">
          Are you sure you want to remove access to the {workspaceData?.name} workspace for{" "}
          {userData?.userName}?
        </Text>
        <Text variant="regular-lg" marginBottom="xl">
          Any active work assigned to {userData?.userName} will be need to be unassigned.
        </Text>

        <Flex gap={SPACING.MEDIUM} justifyContent="end">
          <Button variant="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleRemoveUser}
            isLoading={loading}
            disabled={loading}
          >
            Remove user from workspace
          </Button>
        </Flex>
      </ModalV2.Body>
    </ModalV2>
  );
};

export default RemoveUserModal;
